import { H5, Icon } from "@sellar-io/components";
import { useState } from "react";
import { useNavigate } from "react-router";
import * as ROUTES from "../../constants/routes";
import { useAvailabilityTierCreate } from "../../hooks/api/v2/availabilityTier/useAvailabilityTierCreate";
import { AvailabilityTierNameForm } from "./components/AvailabilityTierNameForm";

export const AvailabilityTierNewDetail = () => {
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const availabilityTierCreate = useAvailabilityTierCreate();

  return (
    <div className="flex flex-col gap-4 p-4">
      <AvailabilityTierNameForm
        name={name}
        onNameChange={setName}
        action="Create"
        loading={availabilityTierCreate.isPending}
        helpContent={<CreateHelpContent />}
        onSubmit={() => {
          availabilityTierCreate.mutate(
            { name, PriceTierId: null },
            {
              onSuccess: (response) =>
                navigate(
                  ROUTES.AVAILABILITY_TIER.href({
                    availabilityTierId: response.id,
                  }),
                ),
            },
          );
        }}
      />
    </div>
  );
};

const CreateHelpContent = () => (
  <>
    <div className="absolute top-[-7px] left-1/2 -translate-x-1/2">
      <div className="h-3 w-3 rotate-45 transform border-t border-l border-gray-300 bg-white" />
    </div>
    <div className="flex flex-row items-center gap-2">
      <Icon icon="INFORMATION_OUTLINE" className="flex-none" />
      <div className="flex flex-col">
        <H5>Create your Product catalogue by giving it a name</H5>
        <p>
          Suggested names could be Full range, Core range, or Excluding
          returnables, for e.g.
        </p>
      </div>
    </div>
  </>
);
